module.exports = __webpack_public_path__ + "img/support-contact-illustration.45e798dd.png";